import React, { FC, memo, useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'app/config/storeConfig/hooks';
import { Drawer } from 'shared/ui/Drawer';
import { waitingListEntryDrawerActions } from '../model/slice/waitingListEntryDrawerSlice';
import { getWaitingListEntryDrawerState } from '../model/selectors/getNoteDrawerState';
import { WaitingListEntryForm } from './WaitingListEntryForm';
import { chooseUserModalActions } from 'widgets/ChooseUserModal';

export const WaitingListEntryDrawer: FC = memo(() => {
  const dispatch = useAppDispatch();

  const waitingListEntryDrawerState = useAppSelector(getWaitingListEntryDrawerState);

  const closeNoteDrawer = useCallback((): void => {
    dispatch(waitingListEntryDrawerActions.setOpenWaitingListEntryDrawer({ mode: null, waitingListEntry: null, lead: null, user: null }));
    dispatch(chooseUserModalActions.resetModalState());
  }, [dispatch]);

  return (
    <Drawer width={500} open={Boolean(waitingListEntryDrawerState.mode)} onClose={closeNoteDrawer}>
      <WaitingListEntryForm
        waitingListEntry={waitingListEntryDrawerState?.waitingListEntry}
        lead={waitingListEntryDrawerState?.lead}
        user={waitingListEntryDrawerState?.user}
        mode={waitingListEntryDrawerState.mode}
        onClose={closeNoteDrawer}
      />
    </Drawer>
  );
});
